var isRequired = function (validate) {
    if (validate && validate.isRequired) {
        return true;
    }
    if (Array.isArray(validate)) {
        return validate.some(function (it) { return it.isRequired; });
    }
    return false;
};
export default isRequired;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ra-core/esm/form/isRequired.js
// module id = 993
// module chunks = 0